/**
 * @module UseBellBadge
 * @package @geenius/notifications-react
 * @description Provides the compact badge state used by the bell trigger in
 * the React notifications variant.
 */

/**
 * Bell badge state derived from the unread count.
 */
export interface BellBadgeState {
  count: number
  hasUnread: boolean
  displayCount: string
}

/**
 * Derives bell badge state from an unread count.
 *
 * @param unreadCount Current unread count.
 * @returns Derived badge state for rendering.
 */
export function useBellBadge(unreadCount: number | undefined): BellBadgeState {
  const count = unreadCount ?? 0
  const hasUnread = count > 0
  const displayCount = count > 99 ? '99+' : String(count)

  return { count, hasUnread, displayCount }
}
